import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { shapingString } from "../../logic/utility/textUtil";

interface SompoCategoryButtonProps {
    name: string;
    border?: boolean;
    icon?: string;
    trainingListNavigate: () => void;
}

const SompoCategoryButton = (props: SompoCategoryButtonProps) => (
    <Button
        onClick={() => {
            props.trainingListNavigate();
        }}
        sx={{
            marginRight: "20px",
            flexShrink: 0,
            height: "70px",
            width: "100%",
            bgcolor: "#fff",
            pt: 3,
            pb: 3,
            pl: 2,
            pr: 2,
            transition: "all 0.2s ease-in-out",
            "&:hover": {
                backgroundColor: "#ddd",
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: props.border ? "2px solid #ddd" : "none",
            borderRadius: "7px",
        }}
    >
        <Box
            sx={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                borderRadius: "50%",
                bgcolor: "#D0D8E6",
                mr: 2,
                backgroundImage: `url(${props.icon})`,
                backgroundSize: "cover",
            }}
        />
        <Box sx={{ display: "flex", flexFlow: "column", alignItems: "flex-start" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#444c55", whiteSpace: "nowrap" }}>
                {shapingString(props.name, 10)}
            </Typography>
        </Box>
    </Button>
);

export default SompoCategoryButton;
